import { EBuildingElevatorType } from '../../../../json_query';
import { changeBuildingElevator } from '../../../state/advanced/building_elevator';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingElevator = getMultiSelectParam<EBuildingElevatorType>(
  'Лифт',
  [
    { title: 'Грузовой', value: EBuildingElevatorType.Service },
    { title: 'Тельфер', value: EBuildingElevatorType.Telpher },
    { title: 'Пассажирский', value: EBuildingElevatorType.Passenger },
  ],
  'building_lift_types_type',
  changeBuildingElevator,
);
